import React, { Component } from "react";
import PropTypes from "prop-types";
import { flowRight as compose } from "lodash";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import cx from "classnames";

// components
import Link from "../Link";

//helpers
import history from "../../core/history";

//styles
import s from "./Logo.css";
import { imageCdnUrl } from "../../config";
import defaultIcon from "../../../public/SiteIcons/white-logo.png";

class Logo extends Component {
  static propTypes = {
    siteName: PropTypes.string.isRequired,
    logoImage: PropTypes.string,
    link: PropTypes.string,
    className: PropTypes.string,
    showMenu: PropTypes.bool,
  };

  static defaultProps = {
    siteName: null,
    logoImage: null,
    link: "/",
    showMenu: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      location: null,
    };
  }
  componentDidMount() {
    // This runs only on client
    this.setState({
      location: history.location ? history.location.pathname : null,
    });
  }
  render() {
    // const { siteName, logoImage, link, className, homeLogo, showMenu, layoutType, scrollLogo } = this.props;

    // let location = history.location ? history.location.pathname : null;
    // if (history.location) {
    //     location = history.location.pathname;
    // }

    const { location } = this.state;
    const {
      siteName,
      logoImage,
      link,
      className,
      homeLogo,
      showMenu,
      layoutType,
      scrollLogo,
    } = this.props;

    // Until location is loaded on client, render a fallback or a placeholder
    if (location === null) {
      // You can render a simple placeholder (like siteName or nothing)
      return (
        <Link to={link} className={className}>
          <span></span>
        </Link>
      );
    }

    return (
      <Link to={link} className={className}>
        {homeLogo && location === "/" && !logoImage && layoutType != 2 && (
          <img
            src={`${imageCdnUrl}logo/${homeLogo}`}
            className={cx(!showMenu ? "displayBlock" : "displayNone")}
            onError={(e) => {
              e.currentTarget.src = defaultIcon;
            }}
          />
        )}
        {homeLogo && location === "/" && !logoImage && showMenu && (
          <span className={cx(s.logoColor, s.logoTextTabViewWidth)}>
            {siteName}
          </span>
        )}
        {homeLogo &&
          !scrollLogo &&
          location === "/" &&
          logoImage &&
          layoutType != 2 && (
            <img
              src={`${imageCdnUrl}logo/${homeLogo}`}
              className={cx(!showMenu ? "displayBlock" : "displayNone")}
              onError={(e) => {
                e.currentTarget.src = defaultIcon;
              }}
            />
          )}
        {homeLogo &&
          scrollLogo &&
          location === "/" &&
          logoImage &&
          layoutType == 5 && (
            <img
              src={`${imageCdnUrl}logo/${logoImage}`}
              className={cx(!showMenu ? "displayBlock" : "displayNone")}
              onError={(e) => {
                e.currentTarget.src = defaultIcon;
              }}
            />
          )}
        {homeLogo && location === "/" && logoImage && layoutType == 2 && (
          <img
            src={`${imageCdnUrl}logo/${logoImage}`}
            className={cx(!showMenu ? "displayBlock" : "displayNone")}
            onError={(e) => {
              e.currentTarget.src = defaultIcon;
            }}
          />
        )}
        {homeLogo && location === "/" && showMenu && logoImage && (
          <img
            src={`${imageCdnUrl}logo/${logoImage}`}
            onError={(e) => {
              e.currentTarget.src = defaultIcon;
            }}
          />
        )}
        {!homeLogo && location === "/" && logoImage && (
          <img
            src={`${imageCdnUrl}logo/${logoImage}`}
            onError={(e) => {
              e.currentTarget.src = defaultIcon;
            }}
          />
        )}
        {!homeLogo &&
          !logoImage &&
          siteName &&
          location &&
          location !== "/" && (
            <span className={cx(s.logoColor, s.logoTextTabViewWidth)}>
              {siteName}
            </span>
          )}
        {!homeLogo &&
          !logoImage &&
          siteName &&
          location &&
          location === "/" && (
            <span
              className={cx(
                !showMenu &&
                  (layoutType == "2"
                    ? s.logoColor
                    : layoutType == "5"
                    ? s.whiteColor
                    : s.whiteColor),
                "logoColor",
                s.logoTextTabViewWidth
              )}
            >
              {siteName}
            </span>
          )}
        {!homeLogo && !logoImage && siteName === null && (
          <span className={cx(s.logoColor, s.logoTextTabViewWidth)}>
            Site Name
          </span>
        )}
        {logoImage && location && location !== "/" && (
          <img
            src={`${imageCdnUrl}logo/${logoImage}`}
            onError={(e) => {
              e.currentTarget.src = defaultIcon;
            }}
          />
        )}
        {!logoImage && homeLogo && location && location !== "/" && siteName && (
          <span className={cx(s.logoColor, s.logoTextTabViewWidth)}>
            {siteName}
          </span>
        )}
      </Link>
    );
  }
}

const mapState = (state) => ({
  siteName: state?.siteSettings?.data?.siteName || "Default Logo",
  logoImage: state?.siteSettings?.data?.Logo || "", // safe access with default
  homeLogo: state?.siteSettings?.data?.homeLogo || "", // safe access with default
  showMenu: state?.toggle?.showMenu || false, // safe access with default
  layoutType: state?.siteSettings?.data?.homePageType || "defaultLayout", // safe access with default
});

const mapDispatch = {};

export default compose(connect(mapState, mapDispatch), withStyles(s))(Logo);
